import cssifyObject from 'css-in-js-utils/lib/cssifyObject';
import { processStyleWithPlugins, STATIC_TYPE } from 'fela-utils';

import minifyCSSString from './minifyCSSString';

export default function cssifyStaticStyle(staticStyle, renderer) {
  if (typeof staticStyle === 'string') {
    return minifyCSSString(staticStyle);
  }

  var processedStaticStyle = processStyleWithPlugins(renderer, staticStyle, STATIC_TYPE);

  return cssifyObject(processedStaticStyle);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/node_modules/fela/es/cssifyStaticStyle.js
// module id = 1131
// module chunks = 0